export default class FakturaciaService {


  constructor(server, FileService){
    this.server = server;
    this.FileService = FileService;
  }

  exportXls(data){
    return this.server.asForm("faktura.xls", {data: data});
  }

  readInputXls(file){
    return this.FileService.read(file).then(file => this.server("faktura.input.xls.read", {file: file}));
  }

  createInvoices(){
    return this.server("faktura.input.createInvoices");
  }

  requestMissingPOFDUF(){
    return this.server("faktura.pofduf.requestMissing");
  }

  exportDuf(dateFrom, dateTo, type, language, extUis) {
    this.server.asForm('export-duf', {
      dateFrom: dateFrom,
      dateTo: dateTo,
      type: type,
      language: language,
      extUis: extUis
    });
  }

  exportPof(dateFrom, dateTo, type, language, extUis) {
    this.server.asForm('export-pof', {
      dateFrom: dateFrom,
      dateTo: dateTo,
      type: type,
      language: language,
      extUis: extUis
    });
  }
}



// WEBPACK FOOTER //
// ./src/Fakturacia/FakturaciaService.js